import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map, Observable } from 'rxjs';
import { environment } from '../environments/environments';

import { Entry, EntryPostBody, FollowData } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class WaitingListService {
  readonly #http = inject(HttpClient);

  getBranchAndEntryByFollowCode(code: string): Observable<FollowData> {
    return this.#http.get<FollowData>(`${environment.RESERVE_URL}/WaitingList/Follow/${code}`);
  }

  getEntryPositionData(entryId: string): Observable<Entry> {
    return this.#http.get<Entry>(`${environment.RESERVE_URL}/WaitingList/GetPosition/${entryId}`);
  }

  getEntryById(entryId: string): Observable<Entry> {
    return this.#http.get<Entry>(`${environment.RESERVE_URL}/WaitingList/GetById?entryId=${entryId}`);
  }

  insertEntry(body: EntryPostBody): Observable<Entry> {
    return this.#http
      .post<{ id: string; entryData: Entry }>(`${environment.RESERVE_URL}/WaitingList/InsertEntry`, body)
      .pipe(map(({ entryData, id }) => ({ ...entryData, entryId: id })));
  }

  removeEntry(entryId: string): Observable<void> {
    return this.#http.patch<void>(`${environment.RESERVE_URL}/WaitingList/RemoveEntry`, {
      entryId,
      reason: 'Waiver',
      otherReason: null,
    });
  }
}
